const FEE_VARIANT_ID = 54043016626470; // variant ID of the Cut fee product
const MIN_YARDS = 5;

async function syncCutFee() {
  const cart = await (await fetch('/cart.js')).json();

  const needed = cart.items.filter(i =>
    i.variant_id !== FEE_VARIANT_ID &&
    i.variant_title?.toLowerCase().includes('by yard') &&
    i.quantity < MIN_YARDS
  ).length;

  const feeLine = cart.items.find(i => i.variant_id === FEE_VARIANT_ID);
  const current = feeLine ? feeLine.quantity : 0;
  if (needed === current) return false;

  const post = (url, body) => fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  });

  if (feeLine) await post('/cart/change.js', { id: feeLine.key, quantity: needed });
  else await post('/cart/add.js', { items: [{ id: FEE_VARIANT_ID, quantity: needed }] });
  return true; // cart changed, so re-render it
}

let syncing = false;

function refreshCartUI() {
  if (window.location.pathname.includes('/cart')) {
    location.reload(); // cart page: a reload is simplest
    return;
  }
  document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
}

async function runSync() {
  if (syncing) return;
  syncing = true;
  try {
    if (await syncCutFee()) refreshCartUI();
  } finally {
    syncing = false;
  }
}

document.addEventListener('DOMContentLoaded', runSync);

const originalFetch = window.fetch;
window.fetch = async function (...args) {
  const res = await originalFetch.apply(this, args);
  const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
  if (!syncing && /\/cart\/(add|change|update|clear)/.test(url)) runSync();
  return res;
};